var map = {
	"./-1.jpg": 526,
	"./0.jpg": 527,
	"./1.jpg": 528,
	"./10.jpg": 529,
	"./2.jpg": 530,
	"./3.jpg": 531,
	"./4.jpg": 532,
	"./5.jpg": 533,
	"./6.jpg": 534,
	"./7.jpg": 535,
	"./8.jpg": 536,
	"./9.jpg": 537,
	"./aris.jpg": 463,
	"./atamd.jpg": 464,
	"./belgeler.jpg": 465,
	"./bilge.jpg": 466,
	"./erdem.jpg": 467,
	"./hoyuk.jpg": 468,
	"./kitap.jpg": 538,
	"./tdkbelleten.jpg": 469,
	"./ttkbelleten.jpg": 470,
	"./turkdili.jpg": 471,
	"./turkdunyasi.jpg": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;